import { useEffect, useState } from "react"

export function useAdminExpandedSidebar() {
  const [adminExpandedSidebar, setAdminExpandedSidebar] = useState(false)

  useEffect(() => {
    if (env.admin && adminExpandedSidebar) {
      document.body.classList.add("expanded-sidebar")
    }
    return () => {
      if (env.admin && adminExpandedSidebar) {
        document.body.classList.remove("expanded-sidebar")
      }
    }
  }, [adminExpandedSidebar])

  return { adminExpandedSidebar, setAdminExpandedSidebar }
}
